import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  TableContainer,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { DownloadOutlined } from '@ant-design/icons';
import { ROLENAME } from "../../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    background: "blue",
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: '#FFF2EB',
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const CurrentMonthPipelineDashboard = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [store, setStore] = useState([]);
  const [commonExpCenter, setExpCenter] = useState([]);
  const [storeDateFilter, setPivotDatefilters] = useState({
    startDate: "",
    endDate: "",
    expectedClosureMonth: ""
  });
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [showDetailedModal, setShowDetailedModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const csvButtonRef = useRef(null);
  const [currentMonthPipelineTableCsvData, setCurrentMonthPipelineTableCsvData] = useState([]);
  const currentMonthPipelineTableCsvButtonRef = useRef(null);
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [popMonthData, setPopMonthData] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectLost, setSeletLost] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];

  const fullMonthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
const [pivot, setPivot] = useState('');

  useEffect(() => {
    expCenters();
    checkPivot('currentMonthPipeline')
    setSelectedRole('ALL')
  }, []);

  // Trigger download when data is ready
  useEffect(() => {
    if (triggerDownload && currentMonthPipelineTableCsvData.length > 0) {
      const timer = setTimeout(() => {
        if (currentMonthPipelineTableCsvButtonRef.current?.link) {
          try {
            currentMonthPipelineTableCsvButtonRef.current.link.click();
          } catch (error) {
            console.error("Error triggering CSV download:", error);
            props?.setSnackInfo("Error downloading CSV", "error");
          }
          setTriggerDownload(false);
        } else {
          // Retry if link is not ready
          setTimeout(() => {
            if (currentMonthPipelineTableCsvButtonRef.current?.link) {
              currentMonthPipelineTableCsvButtonRef.current.link.click();
              setTriggerDownload(false);
            }
          }, 200);
        }
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [triggerDownload, currentMonthPipelineTableCsvData]);

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "projectCode", label: "Project No." },
    { key: "leadNumber", label: "Lead No." },
    { key: "clientName", label: "Client Name" },
    { key: "expCtrName", label: "Exp. Ctr Name" },
    { key: "currentStage", label: "Current Stage" },
    { key: "department", label: "Department" },
    { key: "expectedClosureDate", label: "Expected Closure Date" },
    { key: "leadCreatedDate", label: "Lead Created Date" },
    { key: "salesExecutive", label: "Sales Executive" },
    { key: "asm", label: "ASM" },
  ];

  const csvDownloadHandler = async (data) => {
    setLoading(true);
    try {
      let csvArray = [];
      for (let i = 0; i < popMonthData.length; i++) {
        let obj = {
            serialNo: i + 1,
            projectCode: popMonthData[i]?.erpProjectNo || "N/A",
            leadNumber: popMonthData[i]?.lead_no || "N/A",
            clientName: popMonthData[i]?.customerId?.name || "N/A", // Corrected the optional chaining
            expCtrName: popMonthData[i]?.experienceCenterId?.name || "N/A",
            currentStage: popMonthData[i]?.currentStage || "NA",
            department: popMonthData[i]?.departmentId?.name || "NA", 
            expectedClosureDate: popMonthData[i]?.expectedSalesclosureDate ? moment(popMonthData[i]?.expectedSalesclosureDate).format('DD-MM-YYYY'):  "-",
            leadCreatedDate: moment(popMonthData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
            salesExecutive: popMonthData[i]?.salesUser?.name || "NA",
            asm: popMonthData[i]?.salesAssistantManager?.name || "NA",
          };
          
        csvArray.push(obj);
        // obj = {
        //   serialNo: "",
        //   projectCode: "",
        //   clientName: "",
        //   totalValue: "",
        //   expCtrName: "",
        //   salesWonDate: "",
        //   internalDesignSignOffDate: "",
        //   designSignOffDate: "",
        //   materialDeliveryDate: "",
        //   actualCompletionDate: "",
        //   HoldRevocationDate: "",
        //   expectedClosureDate: "",
        //   leadCreatedDate: "",
        //   salesExecutive: "",
        //   asm: ""
        // };
        // csvArray.push(obj);
      }
      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    setLoading(true);
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
  let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));
  let uniqueexperienceCenterId = Array.from(new Set(store.map((el) => el.experienceCenterId)));

  const expCenterData = {};
  store.forEach((el) => {
      if (!expCenterData[el.experienceCenterName]) {
          expCenterData[el.experienceCenterName] = [];
      }
      expCenterData[el.experienceCenterName].push(el);
  });

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter((user) => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers);
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const currentMonthPlData = async (addExpCenter, usersData, selectedSearchType, searchInput) => {
    let expCenterData = addExpCenter?.map((el) => el._id);
    let users = "";
    if ((usersData?.users && usersData?.users.length !== 0) ||(selectedUsers && selectedUsers.length !== 0)) {
      users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
    }
    let obj = {
      startDate: storeDateFilter.startDate,
      endDate: storeDateFilter.endDate,
      expectedClosureMonth: storeDateFilter.expectedClosureMonth,
      selectedExperienceCenter: expCenterData ? expCenterData : "",
      tokenPercentage: selectedValue !== "" ? selectedValue : "",
      users: users ? users : "",
      userExpCenter: userDetails.experienceCenterId,
      lost: selectLost !== "" ? selectLost : "",
      pivotValue: "currentMonthPipeline",
      searchType: selectedSearchType ? selectedSearchType : "",
      search: searchInput ? searchInput.toUpperCase() : "",
      selectedRole: 'ALL'
    };
    props.setLoading(true);
    try {
      let response = await HttpService.getCurrentMonthPlDataBasedOnExpCenter(obj);
      setStore(response.data);
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const checkPivot = async (value) => {
    setPivot(value)
     if (value === 'currentMonthPipeline') {
        currentMonthPlData();
        setSelectedExperienceCenter([]);
        setSelectedUsers([]);
        setSelectedRole("ALL")
        setSearchInput("")
        setSelectedSearchType("")
    } 
}

  const handleSearchType = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  const handleSearch = async (value) => {
    currentMonthPlData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && selectedSearchType && searchInput) {
      handleSearch(searchInput.toUpperCase());
    }
  };

  const clearDateFilter = () => {
    setSearchInput("");
    setSelectedSearchType("");
    setPivotDatefilters({
      startDate: "",
      endDate: "",
      expectedClosureMonth: ""
    })
    currentMonthPlData(selectedExperienceCenter, selectedUsers, "", "");
  };

  const getDataBasedOnClick = async (e, innerEl, status) => {
    let expCenterData = selectedExperienceCenter?.map((el) => el._id)
    let users = ''
    if (selectedUsers && selectedUsers.length !== 0) {
        users = selectedUsers?.map((el) => el._id)
    }
    let obj = {
        startDate: storeDateFilter.startDate,
        endDate: storeDateFilter.endDate,
        expectedClosureMonth: storeDateFilter.expectedClosureMonth,
        status: status,
        selectedExperienceCenter: innerEl?.experienceCenterId ? innerEl?.experienceCenterId : expCenterData,
        userExpCenter: userDetails.experienceCenterId,
        pivotValue: "currentMonthPipeline",
        tokenPercentage: selectedValue !== "" ? selectedValue : "",
        users: users ? users : "",
        searchType: selectedSearchType ? selectedSearchType : "",
        search: searchInput !== "" ? searchInput.toUpperCase() : ""
    }
    if (status === "total") {
      obj.selectedExperienceCenter = innerEl ? innerEl : expCenterData;
    }
    props.setLoading(true);
    obj.role = selectedRole
    try {
        let response = await HttpService.getDataBasedClickCurrentMonthPl(obj);
        setPopMonthData(response.data)
        setShowDetailedModal(true)
    } catch (error) {
        props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false);
}
const storePivotDate = (e) => {
    const { name, value } = e.target;
    setPivotDatefilters({ ...storeDateFilter, [name]: value });
  };

  const handlePivotDateFilter = () => {
    currentMonthPlData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const formatNumberToTwoDecimalPlaces = (value) => {
    return parseFloat(value).toFixed(2);
}
  
  return (
    <div className="App">
      {/* first table */}
      <div>
        <div>
          <Paper className={classes.paper}>
          <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
            {/* {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesUser) && */}
                <>
                    <Grid item xs={12} sm={3}>
                        <TextField
                        id="startDate"
                        name="startDate"
                        label="Lead Created From Date"
                        type="date"
                        variant="outlined"
                        value={storeDateFilter.startDate}
                        onChange={storePivotDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                        id="endDate"
                        name="endDate"
                        label="Lead Created End Date"
                        type="date"
                        variant="outlined"
                        value={storeDateFilter.endDate}
                        onChange={storePivotDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        select
                        labelId="expectedClosureMonth"
                        id="expectedClosureMonth"
                        value={storeDateFilter.expectedClosureMonth}
                        label="Expected Closure Month"
                        name="expectedClosureMonth"
                        onChange={storePivotDate}
                        variant="outlined"
                        fullWidth
                      >
                        {fullMonthNames &&
                          fullMonthNames?.map((el, index) => (
                            <MenuItem key={index} value={el}>
                              {el}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePivotDateFilter}
                        style={{
                            backgroundColor: "#F50057",
                            color: "#fff",
                            padding: "0.4rem 2rem 2rem 2rem",
                        }}
                        className={classes.submitButton}
                        >
                        Submit
                        </Button>
                    </Grid>
                </>
           {/*  } */}
          </Grid>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <TextField
                select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSearchType}
                label="Search Type"
                name="searchType"
                onChange={(e) => handleSearchType(e.target.value)}
                variant="outlined"
                style={{ width: "30%", marginRight: "2%" }}
                size="small"
              >
                {searchTypes &&
                  searchTypes?.map((el, index) => (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Search Input */}
              <TextField
                label="Enter the input"
                name="searched"
                size="small"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={handleKeyDown} // Listening for the "Enter" key press
                variant="outlined"
                style={{ width: "80%" }}
              />

              {/* Search Button */}
              <Button
                disabled={!selectedSearchType || !searchInput}
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                onClick={() => handleSearch(searchInput.toUpperCase())}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearDateFilter}
              >
                Clear Filter
              </Button>
            </div>
          </Paper>
        </div>
        <br />
        <div>
        {/* {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesUser) && */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
              <CSVLink
                data={currentMonthPipelineTableCsvData}
                filename={`Current_Month_Pipeline_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                ref={currentMonthPipelineTableCsvButtonRef}
                style={{ textDecoration: 'none', display: 'none' }}
              />
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                style={{
                  backgroundColor: "#355025",
                  color: "#FFF2EB",
                  padding: "0.4rem 2rem",
                  border: "none"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  // Generate CSV data  to match table structure exactly
                  const csvData = (() => {
                    try {
                      if (!store || store.length === 0) {
                        return [];
                      }

                      const localExpCenterData = {};
                      store.forEach((el) => {
                        if (!localExpCenterData[el.experienceCenterName]) {
                          localExpCenterData[el.experienceCenterName] = [];
                        }
                        localExpCenterData[el.experienceCenterName].push(el);
                      });

                      const localUniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));
                      const localUniqueexperienceCenterId = Array.from(new Set(store.map((el) => el.experienceCenterId)));
                      const localUniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));

                      if (localUniqueexperienceCenterNames.length === 0) {
                        return [];
                      }

                      const csvRows = [];

                      const headerRow = {
                        "Particulars": ""
                      };

                      const headerColumns = [];
                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            // Only add if expCenterCode exists (same as table would show)
                            if (innerEl.expCenterCode) {
                              headerColumns.push(innerEl.expCenterCode);
                            }
                          });
                        }
                      });
                      
                      headerColumns.forEach((expCenterCode) => {
                        if (expCenterCode) {
                          headerRow[expCenterCode] = "";
                        }
                      });
                      headerRow["Grand Total"] = "";
                      csvRows.push(headerRow);

                      // Row 1: Quotation sent
                      const row1 = {
                        "Particulars": "Quotation sent"
                      };
                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              // If this expCenterCode already exists, sum the values (matching table aggregation)
                              if (row1[innerEl.expCenterCode] !== undefined) {
                                row1[innerEl.expCenterCode] += (innerEl.qtSentCount || 0);
                              } else {
                                row1[innerEl.expCenterCode] = innerEl.qtSentCount || 0;
                              }
                            }
                          });
                        }
                      });

                      const row1GrandTotal = Object.keys(row1).reduce((sum, key) => {
                        return (key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row1[key]) || 0) : sum;
                      }, 0);
                      row1["Grand Total"] = row1GrandTotal;
                      csvRows.push(row1);

                      // Row 2: Site Office visit
                      const row2 = {
                        "Particulars": "Site Office visit"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              if (row2[innerEl.expCenterCode] !== undefined) {
                                row2[innerEl.expCenterCode] += (innerEl.siteOfficeVisitCount || 0);
                              } else {
                                row2[innerEl.expCenterCode] = innerEl.siteOfficeVisitCount || 0;
                              }
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row2GrandTotal = Object.keys(row2).reduce((sum, key) => {
                        return (key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row2[key]) || 0) : sum;
                      }, 0);
                      row2["Grand Total"] = row2GrandTotal;
                      csvRows.push(row2);

                      // Row 3: Negotiation
                      const row3 = {
                        "Particulars": "Negotiation"
                      };

                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              // If this expCenterCode already exists, sum the values (matching table aggregation)
                              if (row3[innerEl.expCenterCode] !== undefined) {
                                row3[innerEl.expCenterCode] += (innerEl.negotiationCount || 0);
                              } else {
                                row3[innerEl.expCenterCode] = innerEl.negotiationCount || 0;
                              }
                            }
                          });
                        }
                      });

                      // Grand Total - sum of all displayed cells (the values actually shown in CSV row)
                      const row3GrandTotal = Object.keys(row3).reduce((sum, key) => {
                        return (key !== "Particulars" && key !== "Grand Total") ? sum + (parseFloat(row3[key]) || 0) : sum;
                      }, 0);
                      row3["Grand Total"] = row3GrandTotal;
                      csvRows.push(row3);

                      // Grand Total row - match table structure exactly
                      // Sum all three metrics per exp center code (matching data rows structure)
                      const grandTotalRow = {
                        "Particulars": "Grand Total"
                      };
                      localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                        if (localExpCenterData[experienceCenterName]) {
                          localExpCenterData[experienceCenterName].forEach((innerEl) => {
                            if (innerEl.expCenterCode) {
                              // Sum all three metrics for this entry
                              const total = (innerEl.qtSentCount || 0) + (innerEl.siteOfficeVisitCount || 0) + (innerEl.negotiationCount || 0);
                              // If this expCenterCode already exists, sum the values (handling duplicates)
                              if (grandTotalRow[innerEl.expCenterCode] !== undefined) {
                                grandTotalRow[innerEl.expCenterCode] += total;
                              } else {
                                grandTotalRow[innerEl.expCenterCode] = total;
                              }
                            }
                          });
                        }
                      });
                      const overallGrandTotal = row1GrandTotal + row2GrandTotal + row3GrandTotal;
                      grandTotalRow["Grand Total"] = overallGrandTotal;
                      csvRows.push(grandTotalRow);

                      return csvRows;
                    } catch (error) {
                      console.error("Error generating current month pipeline table CSV:", error);
                      return [];
                    }
                  })();

                  // Set the data and trigger download
                  if (csvData.length > 0) {
                    setCurrentMonthPipelineTableCsvData(csvData);
                    // Use a longer timeout to ensure state is updated
                    setTimeout(() => {
                      setTriggerDownload(true);
                    }, 100);
                  } else {
                    props?.setSnackInfo("No data available to export", "warning");
                  }
                }}
              >
                Download CSV
              </Button>
            </div>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "10px" }}
            >
              <Table style={{ minWidth: "500px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                         text:'white'
                      }}
                    >
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ position: "sticky",
                        left: 0,
                        zIndex: 9,
                        textAlign: "center",
                        color:'white'
                     }}
                    >
                    </StyledTableCell>
                      {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                        <StyledTableCell className={classes.bordercolors} key={index}
                          style={{
                            fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                            fontWeight: 'bolder',
                            textAlign: 'center',
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                            color: 'white'
                          }}>
                          <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                            <span style={{ cursor: "pointer" }}>
                              {experienceCenterName.expCenterCode}
                            </span>
                          </Tooltip>
                        </StyledTableCell>
                      ))}

                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ textAlign: "center" , color:'white', fontWeight:'bolder' }}>
                         Grand Total
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <StyledTableRow>
                   <StyledTableCell rowSpan={6} style={{color: 'black', fontWeight:'bold', textAlign: "center" }}></StyledTableCell>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black', textAlign: "center" }}> Quotation sent </StyledTableCell>
                      {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'countOfQtSent')}
                            >
                               { innerEl.qtSentCount } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black',textAlign: "center" }}>Site Office visit </StyledTableCell>
                    {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'countOfSiteVisitOffice')}
                            >
                               { innerEl.siteOfficeVisitCount } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{background: '#EDEDED', color: 'black',textAlign: "center" }}>Negotiation</StyledTableCell>
                    {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                        <>
                          {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                            <StyledTableCell
                              className={classes.bordercolors}
                              key={dataIndex}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                top: 0,
                                textDecoration:'underline',
                                background: "white",
                                fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? "#355025" : "#1C375D"
                              }}
                              onClick={(e) => getDataBasedOnClick(e, innerEl, 'countNegotiation')}
                            >
                               { innerEl.negotiationCount } 
                            </StyledTableCell>
                          ))}
                        </>
                      ))}
                  </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" , background: '#EDEDED', color:'black', fontWeight: 'bolder'}}>Grand Total</StyledTableCell>
                      {uniqueexperienceCenterId.map((experienceCenterId, index) => (
                        <StyledTableCell className={classes.bordercolors} key={index} style={{ textAlign: "center", cursor: "pointer", color: "#004d40", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={(e) => getDataBasedOnClick(e, experienceCenterId, 'total')}>
                          {
                            formatNumberToTwoDecimalPlaces(
                              store.reduce((total, el) => {
                                  return total + (el.experienceCenterId === experienceCenterId 
                                      ? el.qtSentCount + el.siteOfficeVisitCount + el.negotiationCount 
                                      : 0);
                              }, 0)
                            )
                          }
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
          </div>
        {/* } */}
        </div>
      </div>
     
      <Modal
        title="Current Month Pipeline Data"
        centered
        visible={showDetailedModal}
        onCancel={() => setShowDetailedModal(false)}
        width={1000}
        maskClosable={true}
        footer={null}
      >
        <div className={classes.csv}>
          <CSVLink
            headers={headers}
            filename={`currentMonthPlData.csv`}
            data={csvData}
            ref={csvButtonRef}
          />
          <Button
            onClick={() => csvDownloadHandler(popMonthData)}
            style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
            variant="contained"
            color="secondary"
          >
            Download CSV
          </Button>
        </div>
        {popMonthData && (
          <TableContainer component={Paper} className={classes.table}>
            <Table
              style={{ width: 450 }}
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Sl. No.</StyledTableCell>
                  <StyledTableCell>Project No.</StyledTableCell>
                  <StyledTableCell>Lead No.</StyledTableCell>
                  <StyledTableCell>Client Name</StyledTableCell>
                  <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                  <StyledTableCell>Current Stage</StyledTableCell>
                  <StyledTableCell>Department</StyledTableCell>
                  <StyledTableCell>Expected Closure Date</StyledTableCell>
                  <StyledTableCell>Lead Created Date</StyledTableCell>
                  <StyledTableCell>Sales Executive</StyledTableCell>
                  <StyledTableCell>ASM</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {popMonthData &&
                  popMonthData.map((data, i) => {
                    return (
                      <>
                        <StyledTableRow key={i}>
                          <StyledTableCell>{i + 1}</StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.erpProjectNo ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.erpProjectNo}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.lead_no ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.customerId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.experienceCenterId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.currentStage}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.departmentId?.name}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { data?.expectedSalesclosureDate ? moment(data?.expectedSalesclosureDate).format('DD-MM-YYYY') : '-'}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.createdAt).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesUser ? data?.salesUser?.name : 'NA'}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesAssistantManager ? data?.salesAssistantManager?.name : 'NA'}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(CurrentMonthPipelineDashboard);
